export default __webpack_public_path__ + "static/media/bummer@3x.e69f4963.png";